export default "__VITE_ASSET__bry2zOne__"